// // import React, { useEffect, useState, useCallback } from 'react';
// // import { getAuthHeaders } from '../../lib/authHeaders';

// // // export default async function CommentsPanel({ baseUrl = '', tenantId, eventId, itemId, memberId }) {
// // export default function CommentsPanel({ baseUrl = '', tenantId, eventId, itemId }) {
// //   const [list, setList] = useState([]);
// //   const [text, setText] = useState('');
// //   const [loading, setLoading] = useState(true);
// //   const [submitting, setSubmitting] = useState(false);

// //   // normalize baseUrl (avoid trailing slash)
// //   const base = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;

// //   const path = itemId
// //     ? `/api/events/${tenantId}/events/${eventId}/items/${itemId}/comments`
// //     : `/api/events/${tenantId}/events/${eventId}/comments`;

// //   let storedUser = {};
// //     try {
// //     const raw = localStorage.getItem('user');
// //     // only parse if we got something that looks like JSON
// //     if (raw && raw !== 'undefined') {
// //       storedUser = JSON.parse(raw);
// //     }
// //   } catch (err) {
// //     console.warn('Could not parse stored user, falling back to empty object', err);
// //   }

// // //  const username = storedUser.username || localStorage.getItem('username');
// //  const userId   = storedUser.id;

// //   // compute headers once per load; prefer getAuthHeaders, fall back to props
// //   const makeHeaders = () => {
// //     const h = getAuthHeaders ? getAuthHeaders() : {};
// //     // Fallbacks from props if helper didn't find them
// //     if (!h['x-tenant-id'] && tenantId) h['x-tenant-id'] = String(tenantId);
// //     if (!h['x-user-id'] && userId) h['x-user-id'] = String(userId);
// //     return {
// //       Accept: 'application/json',
// //       ...h,
// //     };
// //   };

// //   const load = useCallback(async () => {
// //     setLoading(true);
// //     try {
// //       const res = await fetch(`${base}${path}`, { headers: makeHeaders() });
// //       if (!res.ok) {
// //         let msg = 'Failed to load comments';
// //         try {
// //           const j = await res.json();
// //           msg = j?.message || msg;
// //         } catch {}
// //         throw new Error(msg);
// //       }
// //       const data = await res.json();
// //       setList(Array.isArray(data?.comments) ? data.comments : []);
// //     } catch (e) {
// //       console.error('Failed to load comments', e);
// //       setList([]);
// //     } finally {
// //       setLoading(false);
// //     }
// // //   }, [base, path, tenantId, memberId]);
// // }, [base, path, tenantId]);


// //   useEffect(() => {
// //     load();
// //   }, [load]);

// //   const submit = async (e) => {
// //     e.preventDefault();
// //     const body = text.trim();
// //     if (!body) return;
// //     setSubmitting(true);
// //     try {
// //       const res = await fetch(`${base}${path}`, {
// //         method: 'POST',
// //         headers: {
// //           'Content-Type': 'application/json',
// //           ...makeHeaders(),
// //         },
// //         body: JSON.stringify({ text: body }),
// //       });
// //       if (!res.ok) {
// //         let msg = 'Failed to add comment';
// //         try {
// //           const j = await res.json();
// //           msg = j?.message || msg;
// //         } catch {}
// //         throw new Error(msg);
// //       }
// //       setText('');
// //       await load();
// //     } catch (e) {
// //       console.error('Failed to add comment', e);
// //       alert(e.message || 'Failed to add comment');
// //     } finally {
// //       setSubmitting(false);
// //     }
// //   };

// //   return (
// //     <div className="comments-panel">
// //       <h5 className="mb-3">Comments</h5>

// //       <form onSubmit={submit} className="mb-3">
// //         <div className="input-group">
// //           <input
// //             className="form-control"
// //             placeholder="Add a comment…"
// //             value={text}
// //             onChange={(e) => setText(e.target.value)}
// //           />
// //           <button className="btn btn-primary" type="submit" disabled={submitting || !text.trim()}>
// //             {submitting ? 'Posting…' : 'Post'}
// //           </button>
// //         </div>
// //       </form>

// //       {loading ? (
// //         <div className="text-muted">Loading comments…</div>
// //       ) : list.length === 0 ? (
// //         <div className="text-muted">No comments yet.</div>
// //       ) : (
// //         <ul className="list-group">
// //           {list.map((c) => (
// //             <li key={c.id} className="list-group-item">
// //               <div className="small text-muted">
// //                 {c.author_name || c.author_username || `Member #${c.user_id}`}{' '}
// //                 • {new Date(c.created_on).toLocaleString()}
// //               </div>
// //               <div>{c.text}</div>
// //             </li>
// //           ))}
// //         </ul>
// //       )}
// //     </div>
// //   );
// // }

// import React, { useEffect, useState, useCallback } from 'react';
// import axios from 'axios';
// // import { getAuthHeaders } from '../../lib/authHeaders';

// export default function CommentsPanel({ baseUrl = '', tenantId, eventId, itemId }) {
//   const [list, setList] = useState([]);
//   const [text, setText] = useState('');
//   const [loading, setLoading] = useState(true);
//   const [submitting, setSubmitting] = useState(false);

//   // normalize baseUrl (avoid trailing slash)
//   const base = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;

//   // ✅ choose the right endpoint based on presence of itemId (messages, not /comments)
//   const listUrl = itemId
//     ? `/api/events/${tenantId}/items/${itemId}/messages`
//     : `/api/events/${tenantId}/${eventId}/messages`;

//   // current user (for headers)
//   let storedUser = {};
//   try {
//     const raw = localStorage.getItem('user');
//     if (raw && raw !== 'undefined') storedUser = JSON.parse(raw);
//   } catch {}

//   const userId = storedUser.id;

//   // headers (merge with your auth helper)
//   const makeHeaders = () => {
//     const h = getAuthHeaders ? getAuthHeaders() : {};
//     if (!h['x-tenant-id'] && tenantId) h['x-tenant-id'] = String(tenantId);
//     if (!h['x-user-id'] && userId) h['x-user-id'] = String(userId);
//     return { Accept: 'application/json', ...h };
//   };

//   // LOAD
//   const load = useCallback(async () => {
//     setLoading(true);
//     try {
//       const { data } = await axios.get(`${base}${listUrl}`, { headers: makeHeaders() });

//       // tolerate several shapes:
//       const rows =
//         Array.isArray(data?.messages) ? data.messages :
//         Array.isArray(data?.comments) ? data.comments :
//         Array.isArray(data)           ? data :
//         [];

//       setList(rows);
//     } catch (e) {
//       console.error('Failed to load messages', e);
//       setList([]);
//     } finally {
//       setLoading(false);
//     }
//   }, [base, listUrl, tenantId, userId]);

//   useEffect(() => { load(); }, [load]);

//   // POST
//   const submit = async (e) => {
//     e.preventDefault();
//     const body = text.trim();
//     if (!body) return;
//     setSubmitting(true);
//     try {
//       await axios.post(
//         `${base}${listUrl}`,
//         { text: body },
//         { headers: { 'Content-Type': 'application/json', ...makeHeaders() } }
//       );
//       setText('');
//       await load(); // or push optimistic item
//     } catch (e) {
//       console.error('Failed to add message', e);
//       alert(e?.response?.data?.message || e.message || 'Failed to add message');
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   return (
//     <div className="comments-panel">
//       <h5 className="mb-3">Comments</h5>

//       <form onSubmit={submit} className="mb-3">
//         <div className="input-group">
//           <input
//             className="form-control"
//             placeholder="Add a comment…"
//             value={text}
//             onChange={(e) => setText(e.target.value)}
//           />
//           <button className="btn btn-primary" type="submit" disabled={submitting || !text.trim()}>
//             {submitting ? 'Posting…' : 'Post'}
//           </button>
//         </div>
//       </form>

//       {loading ? (
//         <div className="text-muted">Loading comments…</div>
//       ) : list.length === 0 ? (
//         <div className="text-muted">No comments yet.</div>
//       ) : (
//         <ul className="list-group">
//           {list.map((c) => (
//             <li key={c.id} className="list-group-item">
//               <div className="small text-muted">
//                 {c.author_name || c.author_username || `Member #${c.user_id}`}{' '}
//                 • {new Date(c.created_at || c.created_on).toLocaleString()}
//               </div>
//               <div>{c.text || c.message || c.body || c.comment}</div>
//             </li>
//           ))}
//         </ul>
//       )}
//     </div>
//   );
// }

import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';

export default function CommentsPanel({ baseUrl = '', tenantId, eventId, itemId }) {
  const [list, setList] = useState([]);
  const [text, setText] = useState('');
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);

  const base = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;

  const listUrl = itemId
    ? `/api/events/${tenantId}/events/${eventId}/items/${itemId}/comments`
    : `/api/events/${tenantId}/events/${eventId}/comments`;

  // current user
  let storedUser = {};
  try {
    const raw = localStorage.getItem('user');
    if (raw && raw !== 'undefined') storedUser = JSON.parse(raw);
  } catch {}
  const userId = storedUser.id;

  // LOAD
  const load = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await axios.get(`${base}${listUrl}`);
      const rows =
        Array.isArray(data?.comments) ? data.comments :
        Array.isArray(data) ? data : [];
      setList(rows);
    } catch (e) {
      console.error('Failed to load comments', e);
      setList([]);
    } finally {
      setLoading(false);
    }
  }, [base, listUrl]);

  useEffect(() => { load(); }, [load]);

  // POST
  const submit = async (e) => {
    e.preventDefault();
    const body = text.trim();
    if (!body) return;
    setSubmitting(true);
    try {
      await axios.post(`${base}${listUrl}`, {
        tenantid: tenantId,
        eventid: eventId,
        itemid: itemId || null,
        userid: userId,
        comment: body
      });
      setText('');
      await load();
    } catch (e) {
      console.error('Failed to add comment', e);
      alert(e?.response?.data?.message || e.message || 'Failed to add comment');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="comments-panel">
      <h5 className="mb-3">Comments</h5>

      <form onSubmit={submit} className="mb-3">
        <div className="input-group">
          <input
            className="form-control"
            placeholder="Add a comment…"
            value={text}
            onChange={(e) => setText(e.target.value)}
          />
          <button className="btn btn-primary" type="submit" disabled={submitting || !text.trim()}>
            {submitting ? 'Submitting…' : 'Comment'}
          </button>
        </div>
      </form>

      {loading ? (
        <div className="text-muted">Loading comments…</div>
      ) : list.length === 0 ? (
        <div className="text-muted">No comments yet.</div>
      ) : (
        <ul className="list-group">
          {list.map((c) => (
            <li key={c.id} className="list-group-item">
              <div className="small text-muted">
                {c.username || `User #${c.userid}`} •{' '}
                {new Date(c.createdon).toLocaleString()}
              </div>
              <div>{c.comment}</div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

